// attribution.js

const KEYS = {
  FIRST: "ad_first_touch",
  LAST: "ad_last_touch",
};

let initialized = false;

function getParams() {
  const url = new URL(window.location.href);

  const search = Object.fromEntries(url.searchParams.entries());

  let hash = {};
  if (url.hash.includes("?")) {
    hash = Object.fromEntries(new URLSearchParams(url.hash.split("?")[1]));
  }

  return { ...search, ...hash };
}

function detectSource(p) {
  if (p.fbclid || p.utm_source === "facebook") return "facebook";
  if (p.gclid || p.utm_source === "google") return "google";
  if (p.ttclid || p.utm_source === "tiktok") return "tiktok";
  if (p.utm_source) return p.utm_source;
  if (p.ad) return p.ad; // 你自定义 ad=xxx
  return "direct";
}

function safeGet(key) {
  try {
    return JSON.parse(localStorage.getItem(key));
  } catch {
    return null;
  }
}

export function initAdTrack() {
  if (initialized) return;
  initialized = true;

  const p = getParams();
  console.log(p);
  
  const source = detectSource(p);

  const data = {
    source,
    ad: p.ad || null,
    fbclid: p.fbclid || null,
    gclid: p.gclid || null,
    ttclid: p.ttclid || null,
    utm: {
      source: p.utm_source || null,
      medium: p.utm_medium || null,
      campaign: p.utm_campaign || null,
    },
    url: window.location.href,
    time: Date.now(),
  };

  // 🥇 first touch（只写一次）
  const first = safeGet(KEYS.FIRST);
  if (!first) {
    localStorage.setItem(KEYS.FIRST, JSON.stringify(data));
  }

  // 🥈 last touch（每次更新）
  localStorage.setItem(KEYS.LAST, JSON.stringify(data));

  // 🍪 给后端（最重要）
  document.cookie = `ad_source=${source}; path=/; max-age=2592000; SameSite=Lax`;

  if (p.ad) {
    document.cookie = `ad=${p.ad}; path=/; max-age=2592000; SameSite=Lax`;
  }
}

export function getAdTrack() {
  return {
    first: safeGet(KEYS.FIRST),
    last: safeGet(KEYS.LAST),
  };
}
